import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Row, Col } from 'react-bootstrap';

import { authModule, chatModule, communicationModule, intlModule } from '@chedri/base';

import DocMeta from 'components/DocMeta';
import CommunicationHeader from 'components/communication/CommunicationHeader';
import CommunicationContacts from 'components/communication/CommunicationContacts';
import Chat from 'components/communication/Chat';
import UserInfos from 'components/communication/UserInfos';

import { generateMetaTags } from 'helpers/metaTags';
import { useHistory, useLocation, useParams } from 'react-router-dom';

let showChatTimoutHandle;

const getLayout = state => state.layout;

function Communication() {
  const { lang, activeChat } = useParams();
  const { replace } = useHistory();
  const { pathname } = useLocation();
  const headerRef = useRef();
  const messages = useSelector(intlModule.selectors.getMessages);
  const { height, headerHeight } = useSelector(getLayout);
  const me = useSelector(authModule.selectors.getAuth);
  const activeContact = useSelector(chatModule.selectors.getActiveContact);
  const items = useSelector(communicationModule.contact.selectors.getList);

  const [communicationHeaderHeight, setCommunicationHeaderHeight] = useState(70);
  const [selectedContact, setSelectedContact] = useState();
  const [showChat, setShowChat] = useState(false);
  const [headerRowColsWidth, setHeaderRowColsWidth] = useState(showChat ? 9 : 12);

  const contactSelected = useCallback(
    contact => {
      setSelectedContact(contact);
      if (contact.id !== activeChat) {
        replace(`/${lang}/account/communication/${contact.id}`);
      }
    },
    [activeChat, lang, setSelectedContact]
  );

  useEffect(() => {
    if (headerRef) {
      setCommunicationHeaderHeight(headerRef.current.offsetHeight);
    }
  }, [headerRef]);

  useEffect(() => {
    setHeaderRowColsWidth(showChat ? 9 : 12);
  }, [showChat]);

  useEffect(() => {
    if (showChatTimoutHandle) {
      clearTimeout(showChatTimoutHandle);
    }
    showChatTimoutHandle = setTimeout(() => {
      setShowChat(
        (selectedContact && !activeContact) ||
          (activeContact && selectedContact && activeContact.id === selectedContact.id)
      );
    }, 100);
  }, [activeContact, selectedContact, setShowChat]);

  useEffect(() => {
    if (!selectedContact || (activeChat != null && selectedContact.id !== activeChat)) {
      const contact = items.find(entry => entry.id === activeChat);
      if (contact) {
        contactSelected(contact);
      }
    }
  }, [activeChat, items, contactSelected]);

  return (
    <DocMeta tags={generateMetaTags(messages.meta.comms_center)}>
      <div style={{ height: height - headerHeight + 'px' }} className="ccc-main relative bg-white">
        <div
          ref={headerRef}
          className="hidden-xs hidden-sm top-left bg-master-lighter"
          style={{ zIndex: 10, width: headerRowColsWidth * (100 / 12) + '%' }}
        >
          {/* Render header */}
          <CommunicationHeader me={me} contact={activeContact} />
        </div>

        <Row className="condensed full-height">
          {/* Column contact list */}
          <Col
            xs={3}
            className="full-height"
            style={{
              height: `calc(100% - ${communicationHeaderHeight}px)`,
              marginTop: communicationHeaderHeight + 'px',
              zIndex: 2,
            }}
          >
            <div
              className="list-view boreded chatter-users relative"
              style={{ height: `calc(100% - ${communicationHeaderHeight}px)` }}
            >
              {/* Render contact list */}
              <CommunicationContacts onItemSelected={contactSelected} />
            </div>
          </Col>
          {showChat && selectedContact && (
            <>
              {/* Column message */}
              <Col
                xs={6}
                className="full-height"
                style={{
                  height: `calc(100% - ${communicationHeaderHeight}px)`,
                  marginTop: communicationHeaderHeight + 'px',
                  zIndex: 2,
                }}
              >
                <div className="chat-view relative" style={{ height: `calc(100% - ${communicationHeaderHeight}px)` }}>
                  <Chat me={me} selectedContact={selectedContact} />
                </div>
              </Col>

              {/* Column contact information */}
              {activeContact && (
                <Col xs={3}>
                  <UserInfos me={me} contact={activeContact} />
                </Col>
              )}
            </>
          )}
        </Row>
      </div>
    </DocMeta>
  );
}

export default Communication;
